type SignOutIconProps = {
  className?: string;
};

const SignOutIcon = ({ className }: SignOutIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2 6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4L13 4C13.55 4 14.0208 4.19583 14.4125 4.5875C14.8042 4.97917 15 5.45 15 6V8C15 8.28333 14.9042 8.52083 14.7125 8.7125C14.5208 8.90417 14.2833 9 14 9C13.7167 9 13.4792 8.90417 13.2875 8.7125C13.0958 8.52083 13 8.28333 13 8L13 6L4 6L4 18H13V16C13 15.7167 13.0958 15.4792 13.2875 15.2875C13.4792 15.0958 13.7167 15 14 15C14.2833 15 14.5208 15.0958 14.7125 15.2875C14.9042 15.4792 15 15.7167 15 16L15 18C15 18.55 14.8042 19.0208 14.4125 19.4125C14.0208 19.8042 13.55 20 13 20H4C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18L2 6ZM18.175 11L17.275 10.1C17.075 9.9 16.9792 9.66667 16.9875 9.4C16.9958 9.13333 17.1 8.9 17.3 8.7C17.5 8.51667 17.7333 8.42083 18 8.4125C18.2667 8.40417 18.5 8.5 18.7 8.7L21.3 11.3C21.5 11.5 21.6 11.7333 21.6 12C21.6 12.2667 21.5 12.5 21.3 12.7L18.7 15.3C18.5167 15.4833 18.2875 15.575 18.0125 15.575C17.7375 15.575 17.5 15.4833 17.3 15.3C17.1 15.1 17 14.8625 17 14.5875C17 14.3125 17.1 14.075 17.3 13.875L18.175 13L10 13C9.71667 13 9.47917 12.9042 9.2875 12.7125C9.09583 12.5208 9 12.2833 9 12C9 11.7167 9.09583 11.4792 9.2875 11.2875C9.47917 11.0958 9.71667 11 10 11H18.175Z"
      fill="#212121"
    />
  </svg>
);

export default SignOutIcon;
